exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-link[data-v-3b1f25bd]{cursor:pointer}.scroll-row[data-v-3b1f25bd]{overflow:hidden}", ""]);

// exports
